<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogAddAir"
    :before-close="doClose"
    width="80%"
    top="5vh"
  >
    <el-form :ref="refForm" :rules="rules" :model="gateway" label-width="210px">
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item :label="$t('desc.airCompressorSN')">
            <template>
              <span
                style="
                  line-height: 20px;
                  display: block;
                  padding: 6px 0;
                  color: #fff;
                "
                >{{ gateway.dsn }}</span
              >
              <el-row class="infodiv">
                <el-col :xs="24" :sm="24" :md="24" :lg="24">
                  <el-form-item :label="$t('title.airCompressorType')">
                    <el-input
                      v-model="gateway.modelName"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24">
                  <el-form-item :label="$t('desc.customerName')">
                    <el-input
                      v-model="gateway.customerName"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24">
                  <el-form-item :label="$t('title.airCompressorService')">
                    <el-input
                      v-model="gateway.serviceType"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item :label="$t('desc.gatewaySN')" prop="gsn">
            <template>
              <el-select
                v-model="gateway.gatewayId"
                filterable
                :placeholder="$t('desc.select')"
                @change="selectName"
              >
                <el-option
                  v-for="item in gsnList"
                  :key="item.id"
                  :label="item.gsn"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-row class="infodiv">
                <el-col :xs="24" :sm="24" :md="24" :lg="24">
                  <el-form-item :label="$t('desc.signalStrength')">
                    <el-input
                      :disabled="true"
                      v-model="gateway.signal"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24">
                  <el-form-item label="dbm">
                    <el-input :disabled="true" v-model="gateway.dbm"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
          </el-form-item>
        </el-col>

        <el-col :span="12" v-if="deviceModelType != 'PAC'">
          <el-form-item :label="$t('title.controlsCCN')" prop="ccn">
            <template>
              <el-select
                @change="ccnChange"
                v-model="gateway.ccn"
                filterable
                :placeholder="$t('desc.select')"
              >
                <el-option
                  v-for="item in ccnList"
                  :key="item.ccn"
                  :label="item.ccn"
                  :value="item.ccn"
                >
                </el-option>
              </el-select>
            </template>
          </el-form-item>
        </el-col>

        <el-col :span="12" v-if="deviceModelType != 'PAC'">
          <el-form-item :label="$t('title.ccnVersion')" prop="ccnVersion">
            <template>
              <el-select
                v-model="gateway.ccnVersion"
                filterable
                :placeholder="$t('desc.select')"
              >
                <el-option
                  v-for="item in ccnVersionOptions"
                  :key="item.version"
                  :label="item.version"
                  :value="item.version"
                >
                </el-option>
              </el-select>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="deviceModelType == 'PAC'">
          <el-form-item :label="$t('title.controlsCCN')" prop="ccn">
            <template>
              <el-button type="primary" @click="showSETccnDialog(true)"
                >{{ $t("title.pacCcnSetting") }}
              </el-button>
            </template>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="  " style="margin-top: 0px">
            <template>
              <el-row class="infodiv smallForm">
                <el-col :span="24">
                  <el-radio-group
                    @change="changeCcnType"
                    v-model="gateway.ccnType"
                  >
                    <el-radio label="RTU">RTU</el-radio>
                    <el-radio label="TCP">TCP</el-radio>
                  </el-radio-group>
                  <div v-if="gateway.ccnType == 'RTU'">
                    <el-col :span="12">
                      <el-form-item :label="$t('desc.BaudRate')">
                        <el-select
                          v-model="gateway.ccnBaudrate"
                          :placeholder="$t('desc.select')"
                        >
                          <el-option value="9600">9600</el-option>
                          <el-option value="19200">19200</el-option>
                          <el-option value="115200">115200</el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('desc.ccnDatabits')">
                        <el-select
                          v-model="gateway.ccnDatabits"
                          :placeholder="$t('desc.select')"
                        >
                          <el-option value="8">8</el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('desc.ccnStopbit')">
                        <el-select
                          v-model="gateway.ccnStopbit"
                          :placeholder="$t('desc.select')"
                        >
                          <el-option value="0">0</el-option>
                          <el-option value="1">1</el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('desc.ccnCheckbit')">
                        <el-select
                          v-model="gateway.ccnCheckbit"
                          :placeholder="$t('desc.select')"
                        >
                          <el-option
                            value="o"
                            :label="$t('desc.oddNumber')"
                          ></el-option>
                          <el-option
                            value="e"
                            :label="$t('desc.evenNumber')"
                          ></el-option>
                          <el-option
                            value="n"
                            :label="$t('desc.none')"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('desc.ccnCom')">
                        <el-select
                          v-model="gateway.ccnCom"
                          :placeholder="$t('desc.select')"
                          filterable
                          allow-create
                          default-first-option
                        >
                          <el-option value="COM1" label="COM1"></el-option>
                          <el-option value="COM2" label="COM2"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </div>
                  <div v-if="gateway.ccnType == 'TCP'">
                    <el-col :span="12">
                      <el-form-item :label="$t('desc.IP')">
                        <!-- <el-input
                          v-if="deviceModelType == 'PAC'"
                          v-model="gateway.ccnIp"
                          value="192.168.2.100"
                        ></el-input>
                        <el-input
                          v-else
                          v-model="gateway.ccnIp"
                          value=""
                        ></el-input> -->
                        
                        <el-autocomplete
                          v-model="gateway.ccnIp"
                          :fetch-suggestions="ipQuerySearch"
                          @select="handleIpSelect"
                        ></el-autocomplete>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('desc.port')">
                        <!-- <el-input
                          v-if="deviceModelType == 'PAC'"
                          v-model="gateway.ccnPort"
                          value="502"
                        ></el-input>
                        <el-input
                          v-else
                          v-model="gateway.ccnPort"
                          value=""
                        ></el-input> -->
                        <el-autocomplete
                          v-model="gateway.ccnPort"
                          :fetch-suggestions="portQuerySearch"
                          @select="handlePortSelect"
                        ></el-autocomplete>
                      </el-form-item>
                    </el-col>
                  </div>
                </el-col>
              </el-row>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <el-button
              v-if="subButtonAuth"
              type="success"
              :loading="loading"
              @click="onSubBtn(refForm)"
              >{{ $t("button.confirm") }}</el-button
            >
            <el-button @click="doClose">{{ $t("button.cancel") }}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      :title="$t('title.pacCcnSetting')"
      :visible.sync="setCCN"
      width="80%"
      top="5vh"
      append-to-body
    >
      <el-form ref="ccnform" :model="ccnform" label-width="120px">
        <el-row :gutter="24">
          <el-col :md="6" :xs="24" :sm="24">
            <el-form-item :label="$t('title.brandDisplay')">
              <el-select
                size="small"
                v-model="ccnform.brand"
                :placeholder="$t('desc.select')"
              >
                <el-option
                  v-for="item in brandList"
                  :key="item.brandCode"
                  :label="item.brandName"
                  :value="item.brandCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="18" :xs="24" :sm="24">
            <el-form-item :label="$t('title.controllerModel')">
              <el-select
                size="small"
                v-model="ccnform.ccnmodel"
                @change="ccnModelChange"
                :placeholder="$t('desc.select')"
                style="max-width: 140px"
              >
                <el-option label="Xe-145F" value="Xe-145F"> </el-option>
                <el-option label="MU" value="MU"> </el-option>
              </el-select>

              <el-upload
                v-if="ccnform.ccnmodel == 'MU'"
                ref="uploadExcel"
                action="#"
                :auto-upload="false"
                :file-list="fileList"
                :data="postData"
                :on-change="onUploadChange"
                :on-success="handleSuccess"
                :on-exceed="exceedFile"
                :on-error="handleError"
                :before-upload="onBeforeUpload"
                :on-remove="remove"
                accept=".*"
                class="ccnUploadDiv"
              >
                <el-button slot="trigger" size="small" type="primary">{{
                  $t("desc.pacCcnImportController")
                }}</el-button>
              </el-upload>
              <a
                v-if="ccnform.ccnmodel == 'MU' && activeLang == 'en'"
                class="el-button el-button--default el-button--small"
                style="text-decoration: none; float: right"
                href="/file/Excel Import Template - MUCcn.xlsx"
                download="Excel Import Template - MUCcn.xlsx"
                >{{ $t("desc.pacCcnDealImportTemplate") }}</a
              >
              <a
                v-if="ccnform.ccnmodel == 'MU' && activeLang == 'zh'"
                class="el-button el-button--default el-button--small"
                style="text-decoration: none; float: right"
                href="/file/MU点表模板.xlsx"
                download="MU点表模板.xlsx"
                >{{ $t("desc.pacCcnDealImportTemplate") }}</a
              >

              <el-upload
                v-if="ccnform.ccnmodel == 'MU'"
                ref="uploadExcel"
                action="#"
                :auto-upload="false"
                :file-list="fileList"
                :data="postData"
                :on-change="onUploadDealChange"
                :on-success="handleSuccess"
                :on-exceed="exceedFile"
                :on-error="handleError"
                :before-upload="onBeforeUpload"
                :on-remove="remove"
                accept=".*"
                class="ccnUploadDiv"
                style="float: right"
              >
                <el-button slot="trigger" size="small" type="primary">{{
                  $t("desc.pacCcnImportDealed")
                }}</el-button>
              </el-upload>
              <!-- <a
                v-if="ccnform.ccnmodel == 'MU'"
                class="el-button el-button--default el-button--small"
                style="text-decoration: none; float: right"
                href="/file/MU控制器点表模板.csv"
                download="MU控制器点表模板.csv"
                >{{ $t("desc.pacCcnImportTemplate") }}</a
              > -->
            </el-form-item>
          </el-col>
        </el-row>

        <div class="tableDiv" style="margin-top: 20px">
          <el-table
            :data="CCNTable"
            ref="CCNTable"
            @selection-change="handleSelectionChange"
            @row-click="CCNbtn"
            stripe
            class="formSTable ccntable"
            :empty-text="$t('desc.noData')"
            :height="CCNheight"
          >
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column
              type="index"
              :label="$t('title.serialNumber')"
              width="60"
            >
            </el-table-column>
            <el-table-column
              :label="$t('title.monitorIndex')"
              prop="name"
              min-width="30%"
            >
            </el-table-column>
            <el-table-column
              :label="$t('title.monitorDesc')"
              prop="nameZH"
              min-width="20%"
            >
            </el-table-column>
            <el-table-column
              :label="$t('title.monitorDataType')"
              prop="type"
              min-width="15%"
            >
            </el-table-column>
            <el-table-column
              :label="$t('title.monitorUnit')"
              prop="unit"
              min-width="15%"
            >
            </el-table-column>
            <el-table-column
              :label="$t('title.monitorType')"
              prop="rateType"
              min-width="15%"
            >
            </el-table-column>
            <el-table-column
              :label="$t('title.monitorAddress')"
              min-width="15%"
            >
              <template slot-scope="scope">
                <el-input ref="addressInputRef" v-model="scope.row.address">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="偏移量" min-width="15%">
              <template slot-scope="scope">
                <el-input ref="offsetInputRef" v-model="scope.row.offset">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="缩放量" min-width="15%">
              <template slot-scope="scope">
                <el-input ref="scaleInputRef" v-model="scope.row.scale">
                </el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-form-item style="margin-bottom: 0; margin-top: 10px">
          <el-button type="success" :plain="true" v-on:click="addCcnGather">{{
            $t("button.confirm")
          }}</el-button>
          <el-button v-on:click="cancelCcnGather">{{
            $t("button.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-dialog>
</template>

<script>
import XLSX from "xlsx";
import {
  GetGatewaysWithoutUse,
  getPacGatherListByModel,
  importMuCcnFile,
  importMuDealCcnFile,
} from "../../../api/api";
import { mapGetters } from "vuex";
export default {
  name: "index",
  props: {
    loading: false,
    deviceModelType: "",
    subButtonAuth: false,
    dialogAddAir: false,
    title: "",
    refForm: "",
    gateway: {
      dsn: "",
      modelName: "",
      customerName: "",
      serviceType: "",
      gsn: "",
      gatewayId: "",
      signal: "",
      dbm: "",
      ccn: "",
      ccnType: "",
      ccnBaudrate: "",
      ccnDatabits: "",
      ccnStopbit: "",
      ccnCheckbit: "",
      ccnCom: "",
      ccnIp: "",
      ccnPort: "",
      ccnVersion: "",
      ccnGatherList: [],
      ccnModel: "",
    },
    ccnList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    ccnVersionOptions: {
      type: Array,
      default: function () {
        return [];
      },
    },
    uploadMuDatalist: [],
    uploadMuDealDatalist: [],
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("tips.needed")));
      }
    };
    return {
      rules: {
        gsn: [{ required: true, message: " ", trigger: ["blur", "change"] }],
        ccn: [{ required: true, message: " ", trigger: ["blur", "change"] }],
      },
      gsnList: [],
      setCCN: false,
      changeBindFlag: true,
      ccnform: {
        ccn: "",
        type: "1",
        version: "",
        ccnmodel: "",
        brand: localStorage.getItem("user_brand")
          ? localStorage.getItem("user_brand")
          : "IR",
      },
      brandList: [],
      CCNTable: [],
      CCNTableFlag: false,
      CCNheight: 220,
      postData: {},
      fileList: [],
      ipOptions: [
        { value: '192.168.2.100' },
        { value: '192.168.2.220' },
        { value: '192.168.1.35' }
      ],
      portOptions: [
        { value: '502' },
        { value: '503' }
      ],
    };
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
  },
  watch: {
    dialogAddAir: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.GetGatewaysWithoutUse();
        }
      },
      deep: true,
    },
    gateway: {
      handler(newValue, oldValue) {
        // if (
        //   newValue != null &&
        //   oldValue != null &&
        //   oldValue.dsn != "" &&
        //   oldValue.dsn != undefined &&
        //   newValue.dsn != "" &&
        //   newValue.dsn != undefined &&
        //   newValue.dsn != oldValue.dsn
        // ) {
        //   this.changeBindFlag = true;
        // }
        if (this.deviceModelType == "PAC") {
          this.gateway.ccnIp = "192.168.2.100";
          this.gateway.ccnPort = "502";
        }
      },
    },
  },
  methods: {
    ipQuerySearch(queryString, cb) {
      // 调用 callback 返回建议列表
      cb(this.ipOptions);
    },
    portQuerySearch(queryString, cb) {
      // 调用 callback 返回建议列表
      cb(this.portOptions);
    },

    handleIpSelect(item) {
      this.gateway.ccnIp = item.value;
    },
    handlePortSelect(item) {
      this.gateway.ccnPort = item.value;
    },
    setHeight() {
      let Height = document.documentElement.clientHeight;

      if (Height > 500) {
        this.CCNheight = Height * 0.9 - 230;
      } else {
        this.CCNheight = 220;
      }
    },
    changeCcnType(val) {
      let that = this;
      this.$emit("changeCcnType", val);
    },
    custChanged(value) {
      let custCode = "";
      for (let index = 0; index < this.custOption.length; index++) {
        if (this.custOption[index].id == value) {
          custCode = this.custOption[index].customerCode;
        }
      }
      this.airform.customerCode = custCode;
    },
    ccnModelChange() {
      this.CCNTable = [];
      this.gateway.ccnModel = this.ccnform.ccnmodel;
      if (this.ccnform.ccnmodel == "Xe-145F") {
        this.getPacGatherListByModel();
      }
    },
    getPacGatherListByModel() {
      let that = this;
      getPacGatherListByModel("Xe-145F").then((res) => {
        let data = res.result;
        if (data != null && data.length > 0) {
          data.forEach(function (o) {
            o.address = o.rate;
          });
        }
        //that.DBMenuTable = data;
        that.CCNTable = data;
        this.gateway.ccnGatherList = data;
        that.$nextTick(() => {
          that.CCNTable.forEach(function (obj) {
            if (obj.isPreset) {
              that.$refs.CCNTable.toggleRowSelection(obj, true);
            }
          });
        });
      });
    },
    addCcnGather() {
      this.changeBindFlag = false;
      var that = this;
      this.gateway.ccnGatherList = that.$refs.CCNTable.selection;
      this.setCCN = false;
    },
    cancelCcnGather() {
      this.setCCN = false;
      this.changeBindFlag = true;
    },
    GetGatewaysWithoutUse() {
      GetGatewaysWithoutUse().then((res) => {
        let data = res.result;
        this.gsnList = data;
      });
    },
    uploadMuCcnFile() {
      let that = this;
      this.gateway.ccnGatherList = [];
      this.importLoading = true;
      var datalist = that.uploadMuDatalist; //that.form.datalist;
      if (datalist == null || datalist == undefined || datalist.length == 0) {
        return;
      }
      // var propertys = Object.keys(datalist[0]);
      // if (propertys.length != 30) {
      //   that.form.datalist = [];
      //   that.$message({
      //     showClose: true,
      //     message: "导入格式不正确",
      //     type: "error",
      //   });
      //   return false;
      // }
      var msgArr = [];
      var index = 2;
      var postData = [];
      datalist.map((v) => {
        if (v.data != null && v.data.length > 0) {
          v.data.map((d) => {
            let obj = {};
            //console.log(d);
            // obj.ModbusAddress = d["Modbus Address"];
            // obj.ProfibusByte = d["Profibus Byte"];
            // obj.Tag = d["Tag"];
            // obj.Description = d["Description"];
            // obj.Precision = d["Precision"];
            // obj.Units = d["Units"];

            obj.ModbusAddress = d["Modbus List"];
            obj.ProfibusByte = d["__EMPTY"];
            obj.Tag = d["__EMPTY_1"];
            obj.Description = d["__EMPTY_2"];
            obj.Precision = d["__EMPTY_3"];
            obj.Units = d["__EMPTY_4"];

            if (
              obj.Description != "" &&
              obj.ModbusAddress != "Modbus Address"
            ) {
              postData.push(obj);
            }

            // if (
            //   obj.ModbusAddress != "" &&
            //   obj.ProfibusByte != "" &&
            //   obj.Tag != "" &&
            //   obj.ModbusAddress != "Modbus Address"
            // ) {
            //   postData.push(obj);
            // }
          });
        }
        // if (msg != "") {
        //   msgArr.push("Excel表格读取数据第" + index + "行异常:" + msg);
        // } else {
        //   if (that.find(postData, obj) > -1) {
        //     msgArr.push(
        //       "Excel表格读取数据第" +
        //         index +
        //         "行异常，已存在相同的空压机序列号" +
        //         obj.AgencyCode
        //     );
        //   } else {
        //     // if (obj.Type=="新增") {

        //     // }
        //     postData.push(obj);
        //   }
        // }
        index++;
      });
      if (msgArr.length > 0) {
        that.$message({
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: msgArr.join("<br/>"),
          type: "error",
        });
        this.importLoading = false;
        return false;
      }
      importMuCcnFile(postData, 2 * 60 * 1000)
        .then((res) => {
          // that.dialogImportClient = false;
          // this.importLoading = false;
          // that.$message({
          //   showClose: true,
          //   message: that.$t("tips.importSuccess"),
          //   type: "success",
          // });
          let data = res.result;
          if (data != null && data.length > 0) {
            data.forEach(function (o) {
              o.address = o.rate;
              if (o.nameZH == "" || o.nameZH == null) {
                o.nameZH = o.name;
              }
            });
          }
          that.CCNTable = data;
          this.gateway.ccnGatherList = data;
          that.$nextTick(() => {
            that.CCNTable.forEach(function (obj) {
              that.$refs.CCNTable.toggleRowSelection(obj, true);
            });
          });
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },

    uploadMuDealCcnFile() {
      let that = this;
      this.gateway.ccnGatherList = [];
      this.importLoading = true;
      var datalist = that.uploadMuDealDatalist; //that.form.datalist;
      if (datalist == null || datalist == undefined || datalist.length == 0) {
        return;
      }
      // var propertys = Object.keys(datalist[0]);
      // if (propertys.length != 30) {
      //   that.form.datalist = [];
      //   that.$message({
      //     showClose: true,
      //     message: "导入格式不正确",
      //     type: "error",
      //   });
      //   return false;
      // }
      var msgArr = [];
      var index = 2;
      var postData = [];
      datalist.map((v) => {
        if (v.data != null && v.data.length > 0) {
          v.data.map((d) => {
            let obj = {};
            if (that.activeLang == 'en') {
              obj.GatherName = d["Monitor Index"];
              obj.GatherNameZH = d["Index Description"];
              obj.DataType = d["Data Type"];
              obj.Unit = d["Unit"];
              obj.RateType = d["Return Type"];
              obj.Address = d["Address"];
              obj.Offset = d["Offset"];
              obj.Scale = d["Scale"];
            } else {
              obj.GatherName = d["监控指标"];
              obj.GatherNameZH = d["指标描述"];
              obj.DataType = d["类型"];
              obj.Unit = d["单位"];
              obj.RateType = d["回传类型"];
              obj.Address = d["地址值"];
              obj.Offset = d["偏移量"];
              obj.Scale = d["缩放量"];
            }
            
            // var msg = "";
            // if (obj.Dsn == undefined || obj.Dsn == "") {
            //   msg = "空压机序列号为空";
            // }
            postData.push(obj);
          });
        }
        // if (msg != "") {
        //   msgArr.push("Excel表格读取数据第" + index + "行异常:" + msg);
        // } else {
        //   if (that.find(postData, obj) > -1) {
        //     msgArr.push(
        //       "Excel表格读取数据第" +
        //         index +
        //         "行异常，已存在相同的空压机序列号" +
        //         obj.AgencyCode
        //     );
        //   } else {
        //     // if (obj.Type=="新增") {

        //     // }
        //     postData.push(obj);
        //   }
        // }
        index++;
      });
      if (msgArr.length > 0) {
        that.$message({
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: msgArr.join("<br/>"),
          type: "error",
        });
        this.importLoading = false;
        return false;
      }
      importMuDealCcnFile(postData, 2 * 60 * 1000)
        .then((res) => {
          let data = res.result;
          if (data != null && data.length > 0) {
            data.forEach(function (o) {
              o.address = o.rate;
              if (o.nameZH == "" || o.nameZH == null) {
                o.nameZH = o.name;
              }
            });
          }
          that.CCNTable = data;
          this.gateway.ccnGatherList = data;
          that.$nextTick(() => {
            that.CCNTable.forEach(function (obj) {
              that.$refs.CCNTable.toggleRowSelection(obj, true);
            });
          });
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    exceedFile(files, fileList) {
      this.$notify.warning({
        title: this.$t("tips.warning"),
        message: this.$t("importError.only") + this.limitNum + this.$t("importError.selectAgain"),
      });
    },
    onUploadChange(file) {
      let that = this;

      const sheet2JSONOpts = {
        /** Default value for null/undefined values */
        defval: "", //给defval赋值为空的字符串
      };
      var file = file.raw;
      // var rABS = true; //是否将文件读取为二进制字符串
      var reader = new FileReader();
      FileReader.prototype.read = function (file) {
        var binary = "";
        var wb; //读取完成的数据
        // var outdata;

        var reader = new FileReader();

        reader.onload = function (e) {
          var bytes = new Uint8Array(reader.result);

          var length = bytes.byteLength;

          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }

          wb = XLSX.read(binary, {
            type: "binary",
          });
          var list = [];
          // outdata就是你想要的东西 excel导入的数据
          wb.SheetNames.forEach((e, index) => {
            var data = XLSX.utils.sheet_to_json(
              wb.Sheets[wb.SheetNames[index]],
              sheet2JSONOpts
            );
            var model = {
              sheetName: wb.SheetNames[index],
              data: data,
            };
            list.push(model);
          });
          that.uploadMuDatalist = list;
          // this.form.datalist =outdata;
          that.uploadMuCcnFile();
        };

        reader.readAsArrayBuffer(file);
      };
      reader.read(file);
    },

    onUploadDealChange(file) {
      let that = this;

      const sheet2JSONOpts = {
        /** Default value for null/undefined values */
        defval: "", //给defval赋值为空的字符串
      };
      var file = file.raw;
      // var rABS = true; //是否将文件读取为二进制字符串
      var reader = new FileReader();
      FileReader.prototype.read = function (file) {
        var binary = "";
        var wb; //读取完成的数据
        // var outdata;

        var reader = new FileReader();

        reader.onload = function (e) {
          var bytes = new Uint8Array(reader.result);

          var length = bytes.byteLength;

          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }

          wb = XLSX.read(binary, {
            type: "binary",
          });
          var list = [];
          // outdata就是你想要的东西 excel导入的数据
          wb.SheetNames.forEach((e, index) => {
            var data = XLSX.utils.sheet_to_json(
              wb.Sheets[wb.SheetNames[index]],
              sheet2JSONOpts
            );
            var model = {
              sheetName: wb.SheetNames[index],
              data: data,
            };
            list.push(model);
          });
          that.uploadMuDealDatalist = list;
          // this.form.datalist =outdata;
          that.uploadMuDealCcnFile();
        };

        reader.readAsArrayBuffer(file);
      };
      reader.read(file);
    },
    // uploadFile(value) {
    //   if (this.form.datalist.length == 0) {
    //     this.$message({
    //       showClose: true,
    //       message: "请选择要导入的文件",
    //       type: "error",
    //     });
    //     return false;
    //   } else {
    //     this.$emit("onSubBtn", true);
    //     this.fileList = [];
    //   }
    // },
    handleSuccess(res, file) {
      this.$notify.success({
        title: this.$t("tips.success"),
        message: this.$t("tips.importSuccess"),
      });
    },
    handleError(err, file) {
      this.$notify.error({
        title: this.$t("tips.error"),
        message: this.$t("tips.importFail"),
      });
    },
    onBeforeUpload(file) {
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      let size = file.size / 1024 / 1024;
      if (extension !== "xlsx" && extension !== "xls") {
        this.fileList = [];
        this.$notify.warning({
          title: this.$t("tips.warning"),
          message: this.$t("importError.onlySelect"),
        });
        return false;
      }
      this.fileList = [{ uid: file.uid, name: file.name, status: "success" }];
      return true;
    },
    remove(file) {
      this.fileList = [];
      this.form.datalist = [];
    },

    onSubBtn(value) {
      var that = this;
      if (this.gateway.ccnType == "RTU") {
        if (
          this.gateway.ccnBaudrate == null ||
          this.gateway.ccnDatabits == null ||
          this.gateway.ccnStopbit == null ||
          this.gateway.ccnCheckbit == null ||
          this.gateway.ccnCom == null
        ) {
          this.$message({
            showClose: true,
            message: this.$t("tips.validate"),
            type: "error",
          });
          return false;
        }
      } else if (this.gateway.ccnType == "TCP") {
        if (this.gateway.ccnIp == null || this.gateway.ccnPort == null) {
          this.$message({
            showClose: true,
            message: this.$t("tips.validate"),
            type: "error",
          });
          return false;
        }
      } else {
        this.$message({
          showClose: true,
          message: this.$t("tips.validate"),
          type: "error",
        });
        return false;
      }
      if (
        this.gateway.ccnGatherList != null &&
        this.gateway.ccnGatherList != undefined &&
        this.gateway.ccnGatherList.length > 0
      ) {
        this.gateway.ccnGatherList.forEach(function (o) {
          o.rate = o.address;
        });
      }
      this.$refs[value].validate((valid) => {
        if (valid) {
          this.$emit("onSubBtn", true);
        } else {
          //if (that.gateway.modelName=="离心机")
          this.$emit("onSubBtn", true);
          //return false;
        }
      });
    },
    doClose() {
      this.changeBindFlag = true;
      this.$emit("dialogVisibleEvent", false);
      var ref = this.refForm;
      this.$refs[ref].resetFields();
    },
    selectName(value) {
      this.gateway.gsn = value
        ? this.gsnList.find((item) => item.id === value).gsn
        : "";
      // console.log(this.gateway.gsn);
      if (this.gateway.gsn.includes('NIRHC')) {
        this.gateway.ccnBaudrate = '115200';
      }

    },
    ccnChange(value) {
      this.$emit("ccnChange", value);
    },
    showSETccnDialog() {
      this.setCCN = true;
      if (this.changeBindFlag) {
        this.ccnform.ccnmodel = "";
        this.CCNTable = [];
      }
      this.setHeight();
    },
    handleSelectionChange(val) {
      //创建ccn时，选择点表目录
      this.multipleSelection = val;
    },
    CCNbtn(row, col, event) {
      //选择点表， 点击行进行勾选
      if (row.address != "" && row.address != null && row.address != undefined)
        this.$refs.CCNTable.toggleRowSelection(row, true);
      else {
        this.CCNTableFlag = !this.CCNTableFlag;
        this.$refs.CCNTable.toggleRowSelection(row, this.CCNTableFlag);
      }
    },
    resize() {
      this.setHeight();
    },
  },
};
</script>

<style lang="less" scoped>
.infodiv {
  margin-top: 8px;
  padding: 20px;
  border-radius: 16px;
  border: 0px;
  background-color: #1f2128;
  margin-bottom: 10px;
  margin-left: 0 !important;
  .el-form-item {
    margin-top: 0;
  }
}
#formPer .el-form-item__content {
  line-height: 35px;
  border-left: 1px solid #ebeef5;
  padding-left: 10px;
}

#formPer > .el-form-item {
  margin-bottom: 0px;
  border-bottom: 1px solid #ebeef5;
}

#formPer .noborder .el-form-item__content {
  border: 0;
}

#formPer .noborder {
  border: 0;
  margin-top: 20px;
}
.el-input.is-disabled .el-input__icon {
  display: none;
}
</style>
 
